<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    fill="currentColor"
    d="M5.68031 16C5.38051 16 5.19641 15.6941 5.26028 15.4175L6.51747 9.97501H2.43313C2.2602 9.97501 2.10385 9.86367 2.03539 9.69182C1.96693 9.51995 1.9995 9.32048 2.11826 9.18442L10.0047 0.146931C10.1399 -0.00806899 10.3547 -0.0447877 10.5275 0.0576184C10.7003 0.159993 10.7874 0.375649 10.7397 0.582461L9.48253 6.02502H13.5669C13.7398 6.02502 13.8961 6.13633 13.9646 6.3082C14.0331 6.48008 14.0005 6.67955 13.8817 6.81561L5.99535 15.8531C5.91133 15.9494 5.79658 16 5.68031 16Z"
  />
</template>
